<template>
    <div class="min-w-[500px] overflow-auto h-full">
        <div class="flex flex-wrap sm:flex-nowrap items-center justify-between my-4 lg:my-8">
            <!-- title -->
            <div class="order-1 flex-grow flex items-center">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40"
                    class="block w-8 h-8 stroke-current text-navy">
                    <g transform="matrix(1.6666666666666667,0,0,1.6666666666666667,0,0)">
                        <path
                            d="M12.75 15.75h3v4.5l4.5-4.5h1.494a1.506 1.506 0 0 0 1.506-1.506V2.25a1.5 1.5 0 0 0-1.5-1.5h-12a1.5 1.5 0 0 0-1.5 1.5v4.5m11.625 1.125h0"
                            fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"></path>
                        <path
                            d="M19.875 7.875a.375.375 0 1 0 .375.375.375.375 0 0 0-.375-.375m-7.5 0h0m0 0a.375.375 0 1 0 .375.375.375.375 0 0 0-.375-.375m3.75 0h0m0 0a.375.375 0 1 0 .375.375.375.375 0 0 0-.375-.375"
                            fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"></path>
                        <circle cx="6.75" cy="13.125" r="3.375" fill="none" stroke-linecap="round"
                            stroke-linejoin="round" stroke-width="2"></circle>
                        <path d="M12.75 23.25a6.054 6.054 0 0 0-12 0" fill="none" stroke-linecap="round"
                            stroke-linejoin="round" stroke-width="2"></path>
                    </g>
                </svg>

                <span class="ml-2 text-navy font-bold leading-7 text-2xl">
                    Settings
                </span>
            </div>
        </div>

        <flash-message />

        <!-- Table View -->
        <div>
            <div class="mt-2 pb-2">

            </div>

            <div class="flex items-center justify-center">
                <a :href="route('app.settings.download')" 
                class="inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                @click="downloadCSV"
                >Download Lab CSV</a>
            </div>

        </div>
    </div>
</template>

<script>
import AppLayout from "@/Layouts/App";
import IndexMenuItem from '@/Components/IndexMenuItem';
import _ from 'lodash';

export default {
    name: 'settingsManager',
    layout: [AppLayout],
    components: {
        IndexMenuItem
    },

    data() {
        return {
        }
    },

    methods: {
        downloadCSV(){
            axios.get(route('app.settings.download'));
        }
    },
};
</script>
